import { FunctionComponent } from 'preact';
import type { Asset } from '@schibsted-svp/svp-api-types';

import { AssetHorizontal } from '../AssetHorizontal/AssetHorizontal';
import { useViewportType } from '../../hooks/useViewportType';
import { Slider } from '../Slider/Slider';
import { useSliderItemWidth } from '../../hooks/useSliderItemWidth';

interface AssetSliderProps {
  assets: Asset[];
  onAssetClick?: (asset: Asset, event: MouseEvent) => void;
}

export const AssetSlider: FunctionComponent<AssetSliderProps> = ({
  assets,
  onAssetClick,
}) => {
  const { isMobile } = useViewportType();
  const { sliderItemWidth } = useSliderItemWidth();

  return (
    <Slider>
      {assets.map((item) => (
        <AssetHorizontal
          asset={item}
          width={sliderItemWidth}
          disableDescription={isMobile}
          onAssetClick={onAssetClick}
        />
      ))}
    </Slider>
  );
};
